module.exports = __webpack_public_path__ + "img/hero-bg.fc28b26c.png";